import React, { FC } from 'react';

interface ILogOut {
  className: string;
}
const LogOut: FC<ILogOut> = (props) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15648_42)">
      <path
        opacity="0.4"
        d="M5.625 13.8501H3C2.20435 13.8501 1.44129 13.5445 0.87868 13.0005C0.31607 12.4564 0 11.7186 0 10.9492L0 5.14738C0 4.37801 0.31607 3.64015 0.87868 3.09612C1.44129 2.55209 2.20435 2.24646 3 2.24646H5.625C5.72446 2.24646 5.81984 2.28466 5.89016 2.35267C5.96049 2.42067 6 2.5129 6 2.60907V3.81779C6 3.91396 5.96049 4.00619 5.89016 4.0742C5.81984 4.1422 5.72446 4.1804 5.625 4.1804H3C2.73478 4.1804 2.48043 4.28228 2.29289 4.46362C2.10536 4.64497 2 4.89092 2 5.14738V10.9492C2 11.2057 2.10536 11.4516 2.29289 11.633C2.48043 11.8143 2.73478 11.9162 3 11.9162H5.625C5.72446 11.9162 5.81984 11.9544 5.89016 12.0224C5.96049 12.0904 6 12.1826 6 12.2788V13.4875C6 13.5837 5.96049 13.6759 5.89016 13.7439C5.81984 13.8119 5.72446 13.8501 5.625 13.8501Z"
        fill="#213F7D"
      />
      <path
        d="M11.0313 2.9808L15.7781 7.53161C15.8485 7.59904 15.9044 7.67929 15.9425 7.76772C15.9807 7.85615 16.0003 7.95101 16.0003 8.04682C16.0003 8.14263 15.9807 8.2375 15.9425 8.32593C15.9044 8.41436 15.8485 8.49461 15.7781 8.56204L11.0281 13.1189C10.8868 13.2535 10.6962 13.3288 10.4978 13.3282C10.2994 13.3276 10.1093 13.2513 9.96875 13.1159L9.28438 12.4541C9.21298 12.3846 9.15683 12.3019 9.1193 12.2109C9.08177 12.12 9.06363 12.0226 9.06596 11.9247C9.0683 11.8268 9.09106 11.7303 9.13289 11.6411C9.17472 11.5519 9.23475 11.4718 9.30938 11.4055L11.7344 9.25705H5.75C5.65144 9.25729 5.5538 9.23869 5.4627 9.20233C5.37159 9.16597 5.28881 9.11256 5.21912 9.04517C5.14943 8.97778 5.09419 8.89773 5.05659 8.80964C5.01899 8.72154 4.99976 8.62713 5 8.53182V7.56485C4.99976 7.46954 5.01899 7.37513 5.05659 7.28703C5.09419 7.19894 5.14943 7.11889 5.21912 7.0515C5.28881 6.98411 5.37159 6.9307 5.4627 6.89434C5.5538 6.85798 5.65144 6.83938 5.75 6.83962H11.7344L9.30938 4.69113C9.23516 4.62489 9.17555 4.54485 9.1341 4.45579C9.09266 4.36673 9.07025 4.2705 9.0682 4.17286C9.06616 4.07522 9.08453 3.97819 9.12222 3.88759C9.1599 3.79698 9.21612 3.71467 9.2875 3.64559L9.97188 2.98382C10.1121 2.84779 10.3023 2.77108 10.5009 2.77051C10.6995 2.76994 10.8902 2.84557 11.0313 2.9808Z"
        fill="#213F7D"
      />
    </g>
    <defs>
      <clipPath id="clip0_15648_42">
        <rect
          width="16"
          height="15.4716"
          fill="white"
          transform="translate(0 0.3125)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default LogOut;
